export default __webpack_public_path__ + "static/3-cfc01ed3acc4da481e1bbf6e3f3277f8.webp";